var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 629,
    height: 584,
    viewBox: "0 0 629 584",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M315.045 1.11062C390.423 11.7832 406.373 112.251 460.534 165.762C515.407 219.975 630.454 234.148 628.986 311.279C627.513 388.649 513.525 400.631 455.098 451.359C404.652 495.159 381.736 580.014 315.045 583.855C247.599 587.739 208.929 512.731 157.879 468.475C99.6622 418.006 8.56219 387.925 0.627447 311.279C-7.51567 232.62 65.2808 173.3 121.572 117.77C177.307 62.7878 237.534 -9.86378 315.045 1.11062Z",
    fill: "url(#paint0_linear_995_89004)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_995_89004)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.332 95.8834C387.466 61.282 504.656 166.009 539.986 297.864C566.399 396.437 458.888 458.208 362.348 484.076C260.037 511.49 126.354 520.663 98.3623 416.196C61.8364 279.88 124.828 131.656 258.332 95.8834Z",
    fill: "url(#paint1_linear_995_89004)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    clipPath: "url(#clip0_995_89004)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M392.302 377.184C392.284 379.835 391.245 382.372 389.411 384.247C387.576 386.122 385.092 387.185 382.496 387.206H204.413C201.811 387.204 199.317 386.147 197.479 384.267C195.64 382.388 194.607 379.84 194.607 377.184V367.02H372.533V248.933L293.455 321.602L194.607 230.765V215.626C194.607 212.949 195.649 210.382 197.502 208.489C199.356 206.596 201.87 205.533 204.492 205.533H382.417C385.039 205.533 387.553 206.596 389.407 208.489C391.261 210.382 392.302 212.949 392.302 215.626V377.184ZM218.667 225.719L293.455 294.452L368.243 225.719H218.667ZM174.838 326.649H253.916V346.835H174.838V326.649ZM174.838 276.184H224.261V296.37H174.838V276.184Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_995_89004",
    x: 80.1208,
    y: 85.2059,
    width: 471.924,
    height: 428.986,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_995_89004"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_995_89004",
    result: "effect2_dropShadow_995_89004"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_995_89004",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_995_89004",
    x1: 0,
    y1: 292,
    x2: 629,
    y2: 292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_995_89004",
    x1: 81.0079,
    y1: 351.429,
    x2: 522.632,
    y2: 233.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_995_89004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237.234,
    height: 242.231,
    fill: "white",
    transform: "translate(174.838 175.254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMail);
export default __webpack_public_path__ + "static/media/Send_Mail.fdda1af9802c58a3bde8442a70fae697.svg";
export { ForwardRef as ReactComponent };